// The GET payload turned into the shape the panel holds. Modelled on
// taraFeedbackFromAttempt.js, simplified in two ways LNAT's contract allows:
//
// No spans. LNAT's dimension_evidence is free-text quotes, not TARA's
// span-id citations, so there is nothing to resolve against essay text here.
//
// No mark reconciliation. TARA's diagnostic and performance report each
// independently report a mark that can disagree, so taraFeedbackFromAttempt
// checks them against each other. LNAT's composite score is computed once,
// by mastery_scoring, and the examiner_report's snapshot copies it verbatim
// (lnat_scoring_validator.build_executive_summary_snapshot) -- there is only
// ever one number, so there is nothing to reconcile.

import { LNAT_FEEDBACK_STAGES } from './lnatFeedbackGating';

const EMPTY = { phase: 'idle', data: null, error: null, startedAt: null };

function startedAtFrom(row) {
  const raw = row && row.started_at;
  if (typeof raw !== 'string' || !raw) return Date.now();
  const iso = /(Z|[+-]\d{2}:?\d{2})$/.test(raw) ? raw : `${raw}Z`;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return Date.now();
  return Math.min(t, Date.now());
}

export function lnatFeedbackFromAttempt(payload) {
  const stages = {};
  const warnings = [];
  const source = (payload && payload.stages) || {};

  LNAT_FEEDBACK_STAGES.forEach((stage) => {
    const row = source[stage];
    if (!row || row.status === 'not_started') {
      stages[stage] = { ...EMPTY };
      return;
    }

    if (row.status === 'in_progress') {
      stages[stage] = { ...EMPTY, phase: 'running', startedAt: startedAtFrom(row) };
      return;
    }

    if (row.status === 'succeeded') {
      if (!row.student_facing_feedback) {
        warnings.push(`${stage} completed without any feedback to show`);
        stages[stage] = { ...EMPTY, phase: 'error', error: { status: 500 } };
        return;
      }
      stages[stage] = {
        phase: 'ready',
        data: row.student_facing_feedback,
        error: null,
        startedAt: null,
        stale: Boolean(row.stale),
        promptVersion: row.prompt_version || null,
      };
      return;
    }

    stages[stage] = { ...EMPTY, phase: 'error', error: { status: 500 } };
  });

  return { stages, warnings };
}

export function lnatDisplayScore(stages) {
  const report = stages && stages.examiner_report;
  const snapshot = report && report.data && report.data.executive_summary_snapshot;
  const score = snapshot && snapshot.overall_score;
  return typeof score === 'number' ? score : null;
}

export function lnatDisplayBand(stages) {
  const report = stages && stages.examiner_report;
  const snapshot = report && report.data && report.data.executive_summary_snapshot;
  return (snapshot && snapshot.grade_band) || null;
}
